import { message, Modal } from 'antd'
import { useTranslation } from 'react-i18next'
import {
	useAddExecutionStatusMutation,
	useDeleteExecutionStatusMutation,
	useEditExecutionStatusMutation,
} from '../../../../../redux/api/handBooksApi/kurultai/executionStatusApi'
import { EntDirectoryInfoName } from '../../../../../models/directoryInfoName'
import { getCookie } from 'typescript-cookie'

const useExecutionStatus = (modal: any, refresh?: () => void) => {
	const { t } = useTranslation()
	const { confirm } = modal
	const [addExecutionStatus] = useAddExecutionStatusMutation()
	const [deleteExecutionStatus] = useDeleteExecutionStatusMutation()
	const [editExecutionStatus] = useEditExecutionStatusMutation()

	async function onAddExecutionStatus(newExecutionStatus: EntDirectoryInfoName): Promise<boolean> {
		try {
			let status: boolean = false
			await addExecutionStatus(newExecutionStatus)
				.then((response: any) => {
					if (response.error) {
						const isKyrgyz = getCookie('i18next') === 'ky'
						const lang = isKyrgyz ? 'kg' : 'ru'
						const res = response.error.data?.res
						const errorMessages = Array.isArray(res)
							? res.map((error: any) => error[lang] || error.ru).join('\n')
							: response.error.data?.msg || t('unknownError')
						throw new Error(errorMessages)
					}
					if (response.data.success) {
						status = true
						message.success(t('msg.successAdd'))
						if (refresh) refresh()
					}
				})
				.catch((error: any) => {
					modal.error({ title: t('msg.error'), content: String(error.message) })
				})
			return status
		} catch (error: any) {
			modal.error({ title: t('msg.error'), content: String(error.message) })
			return false
		}
	}

	async function onDeleteExecutionStatus(ExecutionStatus: EntDirectoryInfoName) {
		try {
			let status: boolean = false
			confirm({
				centered: true,
				title: t('msg.confirmDeleteText'),
				okText: t('general.yes'),
				cancelText: t('general.no'),
				onOk() {
					deleteExecutionStatus(ExecutionStatus.id as number)
						.then((response: any) => {
							if (response.error !== undefined && response.error.status === 400) {
								status = false
								throw new Error(response.error.data.message)
							}
							if (response.data.success) {
								status = true
								Modal.success({ title: t('msg.successDelete') })
								if (refresh) refresh()
							}
						})
						.catch((error: any) => {
							Modal.error({ title: t('msg.error'), content: String(error.message) })
						})
				},
			})
			return status
		} catch (error: any) {
			Modal.error({ title: t('msg.error'), content: String(error.message) })
			return false
		}
	}

	async function onEditExecutionStatus(
		editedExecutionStatus: EntDirectoryInfoName
	): Promise<boolean> {
		try {
			let status: boolean = false
			await editExecutionStatus(editedExecutionStatus)
				.then((response: any) => {
					if (response.error) {
						const isKyrgyz = getCookie('i18next') === 'ky'
						const lang = isKyrgyz ? 'kg' : 'ru'
						const res = response.error.data?.res
						const errorMessages = Array.isArray(res)
							? res.map((error: any) => error[lang] || error.ru).join('\n')
							: response.error.data?.msg || t('unknownError')
						throw new Error(errorMessages)
					}
					if (response.data.success) {
						status = true
						Modal.success({ title: t('msg.successEdited') })
						if (refresh) refresh()
					}
				})
				.catch((error: any) => {
					Modal.error({ title: t('msg.error'), content: String(error.message) })
				})
			return status
		} catch (error: any) {
			Modal.error({ title: t('msg.error'), content: String(error.message) })
			return false
		}
	}

	return { onAddExecutionStatus, onDeleteExecutionStatus, onEditExecutionStatus }
}

export { useExecutionStatus }
